// extracted by mini-css-extract-plugin
export default {"root":"N2J91aup","specific":"kDprp+CY"};